module.exports = __webpack_public_path__ + "img/logo.169d2f21.png";